import React from "react";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import HighlightText from "../HomePage/HighlightText";
import { DS } from "../../../utils/designSystem";

const GRID_ITEMS = [
  {
    order: -1,
    heading: "Quality Tech Education for",
    highlightText: "Anyone, Anywhere",
    description:
      "KodeVedic brings structured, industry-aligned coding education to students across India - with a special focus on making it accessible to learners in rural and underserved communities.",
    btnText: "Explore Courses",
    btnLink: "/catalog/web-development",
  },
  {
    order: 1,
    heading: "Industry-Aligned Curriculum",
    description:
      "Our courses are built around what real employers need - from Git & GitHub fundamentals to full MERN stack applications and beyond.",
  },
  {
    order: 2,
    heading: "Learn by Doing",
    description:
      "Every concept is paired with hands-on projects, code challenges, and a built-in compiler for 17+ languages so you write real code from day one.",
  },
  {
    order: 3,
    heading: "Certificates That Count",
    description:
      "Complete a course and earn a verifiable certificate that demonstrates your skills to employers and collaborators.",
  },
  {
    order: 4,
    heading: "AI-Assisted Learning",
    description:
      "Stuck on a concept? Use the integrated GPT-4 assistant to get instant, contextual explanations without breaking your flow.",
  },
  {
    order: 5,
    heading: "Career Ready",
    description:
      "From first concept to job-ready portfolio - KodeVedic guides learners through a complete journey: learn, build, showcase, and get hired.",
  },
];

const LearningGrid = () => {
  return (
    <div className="grid mx-auto w-full grid-cols-1 xl:grid-cols-4 rounded-2xl overflow-hidden border border-richblack-700">
      {GRID_ITEMS.map((card, i) => (
        <div
          key={i}
          className={`
            ${i === 0 ? "xl:col-span-2" : ""}
            ${card.order === 3 ? "xl:col-start-2" : ""}
            ${card.order % 2 === 1 ? "bg-richblack-700" : card.order % 2 === 0 ? "bg-richblack-800" : "bg-richblack-900"}
            min-h-[240px] xl:min-h-[260px]
          `}
        >
          {card.order < 0 ? (
            <div className="flex h-full flex-col justify-between gap-4 p-8">
              <div className="text-3xl font-semibold text-richblack-5">
                {card.heading}
                <HighlightText text={card.highlightText} />
              </div>
              <p className={DS.text.body}>{card.description}</p>
              <Link
                to={card.btnLink}
                className={`${DS.btn.primary} w-fit`}
              >
                {card.btnText} <FaArrowRight className="text-xs" />
              </Link>
            </div>
          ) : (
            <div className="flex h-full flex-col gap-4 p-8">
              <h3 className="text-lg font-semibold text-richblack-5">{card.heading}</h3>
              <p className="text-sm text-richblack-300 leading-relaxed">{card.description}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default LearningGrid;
